import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './UserNameField.module.scss';

const UserNameField = ({ value, onChange, disabled, restrictions }) => {
  const handleValueChange = event => {
    if (restrictions && event.target.value.search(restrictions) !== -1) {
      return;
    }

    onChange(event);
  };

  return (
    <div className={styles.userNameField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.userNameId}>
          {credentialForm.userNameLabel}
        </Label>
        <TextField
          id={credentialForm.userNameId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
          autoComplete="off"
        />
      </FormGroup>
    </div>
  );
};

UserNameField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  restrictions: PropTypes.instanceOf(RegExp),
};

UserNameField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
  restrictions: null,
};

export default UserNameField;
